export const getProp = (object, path, value = null) => {
    const pathArray = Array.isArray(path)
        ? path
        : path.split('.').filter((key) => key);

    const pathArrayFlat = pathArray.flatMap((part) =>
        typeof part === 'string' ? part.split('.') : part
    );

    return pathArrayFlat.reduce((obj, key) => obj && obj[key], object) || value;
};

export const getSegments = (regex, str) => {
    const segments = [];
    let lastIndex = 0;
    let match;
    // eslint-disable-next-line no-param-reassign
    regex.lastIndex = 0; // In case there's a dangling previous search
    // eslint-disable-next-line no-cond-assign
    while ((match = regex.exec(str))) {
        if (match.index > lastIndex) {
            segments.push(str.slice(lastIndex, match.index));
        }
        segments.push(match[0]);
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < str.length) {
        segments.push(str.slice(lastIndex));
    }
    return segments;
};

export const titleRegex = /^.*?[.!?\n\r](?:\s|$)/gs;
const trimRegex = /^[\t ]+|[\t ]+$/gm;

export const parsePost = (postText = '') => {
    const [title, body] = getSegments(titleRegex, postText);

    // user submitted an empty string - should fail validation
    if (!title && !body) return { title: null, body: null };

    // if post consists of 1 sentence, set body to empty string
    if (!body) {
        return {
            title: title.replace(trimRegex, ''),
            body: '',
        };
    }

    return { title, body: body.replace(trimRegex, '') };
};

export const autoformatOpts = {
    link: {
        trigger: /[\s]/,
        find: /https?:\/\/[\S]+|(www\.[\S]+)/gi,
        transform: (value, noProtocol) =>
            noProtocol ? `https://${value}` : value,
        format: 'link',
    },
    hashtag: {
        trigger: /[\s]/,
        find: /(?:^|)#[^\s.,;:!?]+/i,
        transform: (value) => value,
        format: 'hashtag',
    },
};
